export default "/images/vendor/flag-icon-css/flags/4x3/gs.svg?c19adcdd5855af626a3c70ddc50f6690";